import {
  ApplicationConfig,
  EnvironmentProviders,
  importProvidersFrom,
  LOCALE_ID,
  makeEnvironmentProviders,
} from '@angular/core';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';

import { environment } from '@personalized-supplements/environments/environment';

import { provideGrpcConfig } from './api/grpc/grpc.config';
import { apiInterceptorProvider } from './providers/api.interceptor.provider';
import { defaultLangProvider } from './providers/default-lang.provider';
import { environmentProvider } from './providers/environment.provider';
import { selectedLangProvider } from './providers/selected-lang.provider';
import { LocaleService } from './services/locale.service';
import { provideCoreStore } from './store';

export const coreConfig: ApplicationConfig = {
  providers: [
    provideCoreStore(),

    MatDatepickerModule,
    MatNativeDateModule,

    environmentProvider,
    apiInterceptorProvider,
    defaultLangProvider,
    selectedLangProvider,
    {
      provide: LOCALE_ID,
      useFactory: (localeService: LocaleService) => localeService.locale(),
      deps: [LocaleService],
    },

    provideGrpcConfig(environment),
    importProvidersFrom(environment.imports),
  ],
};

export function provideCoreConfig(): EnvironmentProviders {
  return makeEnvironmentProviders(coreConfig.providers);
}
